import moment from 'moment'
import config from 'config'

const REQUEST_DATE_FORMAT = 'YYYY-MM-DD'
const urlPrefix = `${config.resourceHost}taxForms`

export const getPeriodParams = ({ startDate, endDate }) => {
  const result = {}
  if (startDate !== null) {
    result['dateFrom'] = moment.parseZone(startDate).format(REQUEST_DATE_FORMAT)
  }
  if (endDate !== null) {
    result['dateTo'] = moment.parseZone(endDate).format(REQUEST_DATE_FORMAT)
  }

  return result
}

export const urls = {
  resource: urlPrefix,
  getBookedTaxFormModulesUrl: () => `${urlPrefix}/taxform-modules/`,
  getTaxFormMetaDataUrl: (formKey) => `${urlPrefix}/${formKey}/meta-data/`,
  saveTaxFormUrl: () => `${urlPrefix}/save`,
  validateTaxFormUrl: () => `${urlPrefix}/validate`,
  sendTaxFormUrl: () => `${urlPrefix}/send`,
  getTicketResponseUrl: (ticketId) => `${urlPrefix}/ticket/${ticketId}`,
  getElsterXmlUrl: (taxFormId) => `${urlPrefix}/${taxFormId}/xml`,
  getTaxFormProtocolUrl: (taxFormId) => `${urlPrefix}/${taxFormId}/protocol`,
  getTaxFormListUrl: () => `${urlPrefix}`,
  getLatestCreatedTaxFormUrl: (formKey) => `${urlPrefix}/${formKey}/latest/`,
  getAvailableYearsUrl: (formKey) => `${urlPrefix}/${formKey}/available-years`,
  createTaxFormProtocolUrl: (formKey) => `${urlPrefix}/${formKey}/protocol/`,
}
